import { forwardRef } from 'react';

export const SaleHorizon1Icon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        width="110"
        height="110"
        viewBox="0 0 110 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M94.4 33.3H15.5V97h78.9V33.3Z"
          stroke="currentColor"
          fill="none"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M94.4 19.1H15.5v14.2h78.9V19.1Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3 29.9c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5Zm61.1 0c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5Z"
          fill="#fff"
        />
        <path
          d="M85.5 13.5v12.9M24.3 13.5v12.9"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.309 56.24v17.52h-3.463V59.756h-.096L38 62.27v-3.285l4.054-2.746h3.255Zm11.576 7.314v2.892h-7.468v-2.892h7.468ZM65.699 74c-1.194 0-2.258-.22-3.19-.659-.928-.445-1.661-1.055-2.2-1.83-.533-.782-.807-1.683-.823-2.704h3.486c.021.428.152.804.392 1.13.245.319.57.567.976.744.405.176.86.265 1.367.265.528 0 .994-.1 1.4-.3.404-.2.722-.476.95-.83.23-.353.345-.76.345-1.223 0-.468-.123-.881-.368-1.24-.24-.365-.587-.65-1.04-.856-.448-.205-.98-.308-1.599-.308h-1.527v-2.72h1.527c.523 0 .984-.097 1.383-.291a2.27 2.27 0 0 0 .944-.804c.224-.348.336-.753.336-1.215 0-.44-.099-.824-.296-1.155a2.007 2.007 0 0 0-.816-.787c-.346-.188-.751-.283-1.215-.283-.47 0-.898.092-1.287.274a2.26 2.26 0 0 0-.936.762c-.235.33-.36.718-.376 1.163h-3.318c.016-1.01.285-1.9.807-2.67.523-.77 1.226-1.37 2.111-1.804.89-.44 1.895-.659 3.015-.659 1.13 0 2.119.22 2.966.659.848.439 1.506 1.032 1.976 1.78.474.74.709 1.573.703 2.497.005.981-.28 1.8-.855 2.456-.57.655-1.314 1.072-2.231 1.249v.137c1.204.165 2.121.613 2.75 1.343.635.724.95 1.63.944 2.72.005.998-.264 1.885-.808 2.66-.538.777-1.282 1.387-2.23 1.832-.95.445-2.037.667-3.263.667Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
